import Grid from '@/global/components/ui/Grid'
import { cpfValido, isCnpjValido } from '@acme/common'
import axios from 'axios'
import { FormDatePicker, FormField } from 'global/components/Form'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { BrasilApiCnpj } from 'types'

export function DadosEmpresa() {
    const { setValue, watch, setError, clearErrors } = useFormContext()

    const document = watch('cnpj')

    useEffect(() => {
        const doc = document?.replace(/\D/g, '').slice(0, 14) || ''

        if (cpfValido(doc)) {
            clearErrors('cnpj')
            setValue(
                'cnpj',
                doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'),
            )
        } else if (isCnpjValido(doc)) {
            axios
                .get<BrasilApiCnpj>(
                    `https://brasilapi.com.br/api/cnpj/v1/${doc}`,
                )
                .then(async ({ data }) => {
                    if (!watch('razaoSocial')) {
                        setValue('razaoSocial', data.razao_social)
                    }
                    if (!watch('nomeFantasia')) {
                        setValue('nomeFantasia', data.nome_fantasia)
                    }
                    if (!watch('uf')) {
                        setValue('uf', data.uf)
                    }
                    if (!watch('cep')) {
                        setValue('cep', data.cep)
                    }
                    if (!watch('Cidade.cidade')) {
                        setValue('Cidade', {
                            cidade: data.municipio,
                            uf: data.uf,
                            ibge: data.codigo_municipio_ibge,
                        })
                    }
                    if (!watch('bairro')) {
                        setValue('bairro', data.bairro)
                    }
                    if (!watch('endereco')) {
                        setValue('endereco', data.logradouro)
                    }
                    if (!watch('numero')) {
                        setValue('numero', data.numero)
                    }
                    if (!watch('telefoneResponsavel')) {
                        setValue(
                            'telefoneResponsavel',
                            data.ddd_telefone_1?.toString(),
                        )
                    }
                    if (!watch('telefone')) {
                        setValue('telefone', data.ddd_telefone_2?.toString())
                    }
                    if (!watch('nomeResponsavel')) {
                        setValue('nomeResponsavel', data.qsa[0].nome_socio)
                    }
                })

            clearErrors('cnpj')
            setValue(
                'cnpj',
                doc.replace(
                    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                    '$1.$2.$3/$4-$5',
                ),
            )
        } else if (doc.length === 11) {
            setError('cnpj', {
                type: 'validate',
                message: 'CPF inválido',
            })
        } else if (doc.length > 11) {
            setValue(
                'cnpj',
                doc.replace(
                    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                    '$1.$2.$3/$4-$5',
                ),
            )
            setError('cnpj', {
                type: 'validate',
                message: 'CNPJ inválido',
            })
        }
    }, [document])

    return (
        <section id="dados-empresa">
            <Grid container spacing={2}>
                <Grid item xs={5}>
                    <FormField
                        name="cnpj"
                        label="CNPJ"
                        required
                        placeholder="00.000.000/0000-00"
                    />
                </Grid>
                <Grid item xs={4}>
                    <FormDatePicker
                        name="competenciaAtual"
                        label="Competência Atual"
                        required
                        type="month"
                    />
                </Grid>
                <Grid item xs={3}>
                    <FormField
                        name="diaInicioPonto"
                        label="Dia Início Ponto"
                        defaultValue="01"
                        required
                        type="number"
                        options={{
                            blocks: [2],
                            numericOnly: true,
                            datePattern: ['d'],
                            date: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormField
                        name="razaoSocial"
                        label="Razão Social"
                        required
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormField
                        name="nomeFantasia"
                        label="Nome Fantasia"
                        required
                    />
                </Grid>
            </Grid>
        </section>
    )
}
